export const isObjectEmpty = (obj: Record<string, unknown>) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};
